<template>
    <div class="field--no-tin">
        <div class="row">
            <CheckBox
                v-model="formData.noTinNumber"
                :name="name"
                cy-data="no-tin"
                class="valid"
            >
                <span class="is-exist-tin-number">
                    {{ $t(`${TRANSLATION_KEY}.isExistTinNumber`) }}
                </span>
            </CheckBox>
        </div>
        <div v-if="formData.noTinNumber" class="row row--absence-of-tin-number">
            <span class="row--absence-of-tin-number__question">
                {{ $t(`${TRANSLATION_KEY}.explainAbsenceOfTin`) }}
            </span>
            <Radio
                :label="$t(`${TRANSLATION_KEY}.tinNumberInformationOne`)"
                :name="name + 'Reason'"
                :value="NoTinReason.NOT_ISSUED"
                cy-data="no-tin-not-issued"
                class="valid"
                @update-value="setNoTinReason"
            />
            <Radio
                :label="$t(`${TRANSLATION_KEY}.tinNumberInformationTwo`)"
                :name="name + 'Reason'"
                :value="NoTinReason.UNABLE_TO_GET"
                :handles-error="false"
                cy-data="no-tin-unable-to-get"
                class="valid"
                @update-value="setNoTinReason"
            />
            <Radio
                :label="$t(`${TRANSLATION_KEY}.tinNumberInformationThree`)"
                :name="name + 'Reason'"
                :value="NoTinReason.OTHER"
                :handles-error="false"
                :class="[
                    formData.noTinNumber && formData.noTinNumberReason !== 3
                        ? 'margin-bottom'
                        : '',
                ]"
                cy-data="no-tin-other"
                class="valid"
                @update-value="setNoTinReason"
            />
        </div>
        <transition name="fade" mode="out-in">
            <div
                v-if="
                    formData.noTinNumberReason === NoTinReason.OTHER &&
                    formData.noTinNumber
                "
                class="row--next-tax-residence__other-reason"
            >
                <Field
                    v-model="formData.noTinNumberOtherReason"
                    type="text"
                    :name="name + 'OtherReason'"
                    :placeholder="
                        $t(`${TRANSLATION_KEY}.otherReasonPlaceholder`)
                    "
                    cy-data="no-tin-reason"
                >
                    <span>{{ $t(`${TRANSLATION_KEY}.reason`) }}</span>
                </Field>
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed, onMounted } from 'vue';
import CheckBox from '@/components/basic/fields/CheckBox.vue';
import Radio from '@/components/basic/fields/Radio.vue';
import Field from '@/components/basic/fields/Field.vue';
import { useStore } from 'vuex';
import { NoTinReason } from '@/constants/form-values';

export default defineComponent({
    name: 'NoTinField',
    components: {
        CheckBox,
        Radio,
        Field,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    emits: ['input'],
    setup(props, { emit }) {
        const store = useStore();
        const TRANSLATION_KEY = 'compositeFields.NoTinField';

        const formData = ref({
            noTinNumber: false,
            noTinNumberReason: null as null | NoTinReason,
            noTinNumberOtherReason: '',
        });

        const taxResidenceData = computed(() => store.state.formData);

        const setNoTinReason = (value: NoTinReason) => {
            formData.value.noTinNumberReason = value;
            if (value !== NoTinReason.OTHER) {
                formData.value.noTinNumberOtherReason = '';
            }
        };

        const emitData = () => {
            emit('input', formData.value);
        };

        const setNoTinNumberOtherReasonFromBackEnd = () => {
            const reason = taxResidenceData.value.secondNoTinNumberReason;
            if (reason && formData.value.noTinNumber) {
                formData.value.noTinNumberReason = reason;
            }
        };

        watch(
            [
                () => formData.value.noTinNumber,
                () => formData.value.noTinNumberReason,
                () => formData.value.noTinNumberOtherReason,
            ],
            emitData
        );

        onMounted(() => {
            setTimeout(() => setNoTinNumberOtherReasonFromBackEnd(), 500);
        });

        return {
            TRANSLATION_KEY,
            formData,
            NoTinReason,
            setNoTinReason,
        };
    },
});
</script>

<style scoped>
.margin-bottom {
    margin-bottom: 1rem;
}
</style>
